import { Redirect } from 'expo-router';

/** The shelf is My books; old links land there. */
export default function Shelf() {
  return <Redirect href="/library" />;
}
